import { useState, useEffect } from 'react';
import './LoadingOverlay.css';

const LOADING_MESSAGES = [
    'SYNCING NEURAL ASSETS...',
    'LOADING SYSTEM DATA...',
    'CONNECTING TO SERVER...',
    'INITIALIZING MODULES...',
    'FETCHING SECURE DATA...',
    'PREPARING DASHBOARD...',
];

export const LoadingOverlay = ({ visible }) => {
    const [currentMsg, setCurrentMsg] = useState(0);

    useEffect(() => {
        if (!visible) return;
        const interval = setInterval(() => {
            setCurrentMsg(prev => (prev + 1) % LOADING_MESSAGES.length);
        }, 2500);
        return () => clearInterval(interval);
    }, [visible]);

    if (!visible) return null;

    const displayMessage = LOADING_MESSAGES[currentMsg];

    return (
        <div className="nx-loading-overlay">
            <div className="nx-loading-card">
                {/* Orbit Animation */}
                <div className="nx-orbit-container">
                    <div className="nx-orbit-ring nx-ring-outer">
                        <div className="nx-orbit-dot"></div>
                    </div>
                    <div className="nx-orbit-ring nx-ring-inner">
                        <div className="nx-orbit-dot"></div>
                    </div>
                    <div className="nx-core-icon">
                        <div className="nx-diamond"></div>
                    </div>
                </div>

                {/* Brand */}
                <h1 className="nx-brand-text">NEXTRON</h1>

                {/* Animated Dots */}
                <div className="nx-loader-dots">
                    <span className="nx-ldot"></span>
                    <span className="nx-ldot"></span>
                    <span className="nx-ldot"></span>
                </div>

                {/* Message */}
                <p className="nx-loading-status">{displayMessage}</p>
            </div>
        </div>
    );
};

export default LoadingOverlay;
